module.exports = __webpack_public_path__ + "img/1484158509.d2fd8ae5.jpg";